import React, { useEffect, useState } from 'react'

import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material'

import { useActivityTimeout } from 'contexts/TimeoutProvider'

import { styles } from './TimeoutModal.styles'

export const TimeoutModal = () => {
	const { showTimeout, resetTimer, handleLogout, getRemainingTime } =
		useActivityTimeout()

	const [timeLeft, setTimeLeft] = useState(0)

	useEffect(() => {
		let timer: NodeJS.Timeout

		if (showTimeout) {
			const updateTimeLeft = () => {
				const remaining = getRemainingTime()
				const remainingSeconds = Math.max(
					0,
					Math.floor(remaining / 1000)
				)
				setTimeLeft(remainingSeconds)

				// Auto logout when timer hits 0
				if (remainingSeconds <= 0) {
					handleLogout()
					clearInterval(timer)
				}
			}

			updateTimeLeft()

			timer = setInterval(updateTimeLeft, 1000)
		}

		return () => {
			if (timer) clearInterval(timer)
		}
	}, [showTimeout, getRemainingTime, handleLogout])

	// Format time as M:SS
	const formatTime = (seconds: number): string => {
		const minutes = Math.floor(seconds / 60)
		const remainingSeconds = seconds % 60
		return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
	}
	const TimeoutBackdrop = ({ children }: { children: React.ReactNode }) => (
		<Box sx={styles.backdropBox}>{children}</Box>
	)

	return (
		<Dialog
			open={showTimeout}
			maxWidth={false}
			fullWidth
			disableEscapeKeyDown
			components={{
				Backdrop: TimeoutBackdrop,
			}}
			PaperProps={{
				sx: styles.paperProps,
			}}
			data-testid="test-timeout-modal"
		>
			<DialogContent sx={styles.modal}>
				<Typography
					variant="h6"
					sx={styles.logoutImpending}
					data-testid="timeout-title"
				>
					Logout Impending
				</Typography>

				<Typography variant="body2" data-testid="timeout-message">
					It looks like you haven&apos;t been active on Brainstorm for
					the last 25 minutes. For your security, we will log you out
					in 5 minutes. Any un-submitted ideas will be lost.
				</Typography>

				<Typography variant="h4" data-testid="timeout-timer">
					{formatTime(timeLeft)}
				</Typography>

				<Box sx={styles.buttonBox}>
					<Button
						variant="contained"
						onClick={resetTimer}
						fullWidth
						sx={styles.stayButton}
						data-testid="stay-logged-in-btn"
					>
						STAY LOGGED IN
					</Button>

					<Button
						variant="outlined"
						onClick={handleLogout}
						fullWidth
						sx={styles.logoutButton}
						data-testid="logout-btn"
					>
						LOGOUT NOW
					</Button>
				</Box>
			</DialogContent>
		</Dialog>
	)
}
